import { apiClient } from "../config";

async function getPollAndSurveyVersions(id: any) {
  const res = await apiClient.get(`/admin/survey-and-polls/${id}/versions`);
  return res.data;
}

export default getPollAndSurveyVersions;
